// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PLeftCircleOutlinedSvg from "@fishx/icons-svg/es/asn/PLeftCircleOutlined";
import FishxIcon from '../components/FishxIcon';

var PLeftCircleOutlined = function PLeftCircleOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PLeftCircleOutlinedSvg
  }));
};

PLeftCircleOutlined.displayName = 'PLeftCircleOutlined';
export default React.forwardRef(PLeftCircleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PLeftCircleOutlined.js
// module id = 3482
// module chunks = 0